import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy, EventEmitter, Input, Output, Renderer, TemplateRef, ViewChild } from '@angular/core';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Producto } from '../../../models/producto';
import { ProductoService } from '../../../services/producto.service';
import { Pagination } from '../../../models/pagination';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from "rxjs/Subscription";
import { InputSearchComponent } from '../../../controls/input-search/input-search.component';
import { ImageModalComponent } from '../image-modal/image-modal.component';
import { ConfigService } from '../../../config/config-service';
import { SessionService } from '../../../services/session.service';
import { environment } from '../../../../environments/environment';

declare var $: any;
declare var JQuery: any;

@Component({
	selector: 'servicio-modal',
	templateUrl: './servicio-modal.component.html',
	styleUrls: ['./servicio-modal.component.css'],
	providers: [ProductoService]
})
export class ServicioModalComponent implements OnInit, OnDestroy {
	@Output() sendProductoPrecio = new EventEmitter();
	@Input() bodega_id: any;
	@Input() es_comprado: boolean;
	@Input() es_vendido: boolean;
	@ViewChild(InputSearchComponent) inputSearch: InputSearchComponent;
	@Input() numero_decimales: number = 2;
	//public title: String;
	public productos: Array<Producto> = [];
	public selectedRow: number;
	private producto;
	public pagination: Pagination;
	public loading = false;
	private _modelSubscription: Subscription;
	public text: String;
	public ruta_imagen: String;
	public config: ConfigService;
	public format_decimal: String;
	public uploadfile_api: String;

	constructor(
		public productoService: ProductoService,
		private NavRoute: Router,
		private storage: AsyncLocalStorage,
		private render: Renderer,
		public bsModalRef: BsModalRef,
		public bsModalRef2: BsModalRef,
		public bsModalRefImg: BsModalRef,
		private modalService: BsModalService,
		public ss: SessionService,
	) {
		//this.title = "Productos";
		this.pagination = new Pagination();
		this.text = "";
		this.config = new ConfigService();
		this.format_decimal = "0,0.00";
		this.uploadfile_api = environment.uploadfile_api;
	}

	ngOnInit() {

		let digitos = "";
		for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
		this.format_decimal = "0,0." + digitos

		this.getProductos();

		this._modelSubscription = this.modalService.onHidden.subscribe((reason: string) => {
			this.getProductos();
		});
	}

	ngAfterViewInit(){
		this.inputSearchListen();
	}

	inputSearchListen(){
		this.inputSearch.onSearch.subscribe(
			res => {
				this.text = res;
			},
			err => {
				//
			}
		);
	}

	ngOnDestroy(){
		if( this._modelSubscription ){
			this._modelSubscription.unsubscribe();
		}
	}

	getProductosBySearch(text){
		let qs = "&q[producto.codigo]=" + text + "&q[producto.nombre]=" + text + "&q[producto.descripcion]=" + text;
		this.pagination.current_page = 1;
		this.getProductos(qs);
	}

	getProductos(qs = "") {
		this.loading = true;
		
		if(this.es_comprado){
			qs += "&es_comprado=" + this.es_comprado;
		}
		if(this.es_vendido){
			qs += "&es_vendido=" + this.es_vendido;
		}

		this.productoService.getServiciosWithPrice('?page='+this.pagination.current_page+'&per_page=10&tipo_producto_id=2' + qs).subscribe(
			res => {
				this.loading = false;
				this.productos = res.data;

				this.pagination.current_page = res.current_page;
				this.pagination.from = res.from;
				this.pagination.to = res.to;
				this.pagination.total = res.total;
				this.pagination.last_page = res.last_page;
				this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
				this.pagination.prev_disabled = this.pagination.current_page === 1;
			},
			err => {
				this.loading = false;
				this.productos = [];
			}
		);
	}

	get formatDecimal(){
        return this.format_decimal;
    }

	onSelectRow(producto, i) {
		//Asignacion de fila
		// this.selectedRow = i;
		//Asignacion de producto
		this.producto = producto;
	}

	onDBLClick(producto, i) {
		this.onSelectRow(producto, i);
		this.onSubmit();
	}

	onSubmit() {
		//envía de objecto producto
		this.sendProductoPrecio.emit(this.producto);
		//Cierre de modal o componente
		// this.bsModalRef.hide();
	}

	next(){
		let qs = "&q[producto.codigo]=" + this.text + "&q[producto.nombre]=" + this.text + "&q[producto.descripcion]=" + this.text;
		this.pagination.current_page++;
		this.getProductos(qs);
	}

	prev(){
		let qs = "&q[producto.codigo]=" + this.text + "&q[producto.nombre]=" + this.text + "&q[producto.descripcion]=" + this.text;
		this.pagination.current_page--;
		this.getProductos(qs);
	}

	first(){
		let qs = "&q[producto.codigo]=" + this.text + "&q[producto.nombre]=" + this.text + "&q[producto.descripcion]=" + this.text;
		this.pagination.current_page = 1;
		this.getProductos(qs);
	}

	last(){
		let qs = "&q[producto.codigo]=" + this.text + "&q[producto.nombre]=" + this.text + "&q[producto.descripcion]=" + this.text;
		this.pagination.current_page = this.pagination.last_page;
		this.getProductos(qs);
	}

	openModal(template: TemplateRef<any>){
		const initialState = {};
		this.bsModalRef2 = this.modalService.show(template, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onImage(producto){
		this.ruta_imagen = this.uploadfile_api + "/image/" + (producto.imagen!=""?producto.imagen:"nofoto.png") + "/300?tk=" + this.ss.getData('api-token') + "&dbname=" + this.ss.getData('dbname');

		const initialState = { title: producto.producto, ruta_image: this.ruta_imagen };
		this.bsModalRefImg = this.modalService.show(ImageModalComponent, Object.assign({}, {class: 'modal-sm', initialState}));
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/servicio-modal/servicio-modal.component.ts